import React from "react"
import { FormattedMessage } from "react-intl"
import { concatClassNames } from "helpers/jsxHelpers"
import "./index.scss"

export interface TextProps {
	title: string
	text: string
	classname?: string
}

const Text: React.FC<TextProps> = ({ title, text, classname }) => {
	return (
		<div className={concatClassNames(["summarycard-text", classname])}>
			<FormattedMessage id={title} />
			<FormattedMessage id={text}>
				{(txt) => <div className="paragraph">{txt}</div>}
			</FormattedMessage>
		</div>
	)
}

export default Text
